
@file:Suppress("unused")
package tk.mallumo.compose.navigation


import androidx.compose.runtime.remember
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.DisposableEffect




object ImplNoteUtils {

    @Composable
    fun navNode(node: NodeInfo) {
        when (node.id) {

            "one.devsbox.www.ui.apps.wheel.detail.AppWheelDUI" ->
                composite(node) { one.devsbox.www.ui.apps.wheel.detail.AppWheelDUI() }

            "one.devsbox.www.ui.apps.wheel.edit.AppWheelEUI" ->
                composite(node) { one.devsbox.www.ui.apps.wheel.edit.AppWheelEUI() }

            "one.devsbox.www.ui.apps.ListingAppsUI" ->
                composite(node) { one.devsbox.www.ui.apps.ListingAppsUI() }

            "one.devsbox.www.ui.login.LoginUI" ->
                composite(node) { one.devsbox.www.ui.login.LoginUI() }

            "one.devsbox.www.ui.resources.detail.ResourceUI" ->
                composite(node) { one.devsbox.www.ui.resources.detail.ResourceUI() }

            "one.devsbox.www.ui.resources.ListingResourcesUI" ->
                composite(node) { one.devsbox.www.ui.resources.ListingResourcesUI() }

            "one.devsbox.www.ui.users.detail.UserDUI" ->
                composite(node) { one.devsbox.www.ui.users.detail.UserDUI() }

            "one.devsbox.www.ui.users.activity.UsersActivityUI" ->
                composite(node) { one.devsbox.www.ui.users.activity.UsersActivityUI() }

            "one.devsbox.www.ui.users.ListingUsersUI" ->
                composite(node) { one.devsbox.www.ui.users.ListingUsersUI() }

            "one.devsbox.www.ui.users.edit.UserEUI" ->
                composite(node) { one.devsbox.www.ui.users.edit.UserEUI() }

            "one.devsbox.www.ui.devices.detail.DeviceDUI" ->
                composite(node) { one.devsbox.www.ui.devices.detail.DeviceDUI() }

            "one.devsbox.www.ui.devices.ListingDevicesUI" ->
                composite(node) { one.devsbox.www.ui.devices.ListingDevicesUI() }

            "one.devsbox.www.ui.devices.edit.DeviceEUI" ->
                composite(node) { one.devsbox.www.ui.devices.edit.DeviceEUI() }

            "one.devsbox.www.ui.campaigns.detail.CampaignDUI" ->
                composite(node) { one.devsbox.www.ui.campaigns.detail.CampaignDUI() }

            "one.devsbox.www.ui.campaigns.ListingCampaignsUI" ->
                composite(node) { one.devsbox.www.ui.campaigns.ListingCampaignsUI() }

            "one.devsbox.www.ui.campaigns.edit.CampaignEUI" ->
                composite(node) { one.devsbox.www.ui.campaigns.edit.CampaignEUI() }

            "one.devsbox.www.ui.company.detail.CompanyDUI" ->
                composite(node) { one.devsbox.www.ui.company.detail.CompanyDUI() }

            "one.devsbox.www.ui.company.ListingCompanyUI" ->
                composite(node) { one.devsbox.www.ui.company.ListingCompanyUI() }

            "one.devsbox.www.ui.company.edit.CompanyEUI" ->
                composite(node) { one.devsbox.www.ui.company.edit.CompanyEUI() }

            "one.devsbox.www.ui.home.HomeUI" ->
                composite(node) { one.devsbox.www.ui.home.HomeUI() }

            "one.devsbox.www.ui.widgets.EmptyUI" ->
                composite(node) { one.devsbox.www.ui.widgets.EmptyUI() }

            "one.devsbox.www.ui.locations.detail.LocationDUI" ->
                composite(node) { one.devsbox.www.ui.locations.detail.LocationDUI() }

            "one.devsbox.www.ui.locations.ListingLocationUI" ->
                composite(node) { one.devsbox.www.ui.locations.ListingLocationUI() }

            "one.devsbox.www.ui.locations.edit.LocationEUI" ->
                composite(node) { one.devsbox.www.ui.locations.edit.LocationEUI() }

            "one.devsbox.www.ui.uploader.UploaderUI" ->
                composite(node) { one.devsbox.www.ui.uploader.UploaderUI() }

            "one.devsbox.www.ui.cmd.CmdUI" ->
                composite(node) { one.devsbox.www.ui.cmd.CmdUI() }

        }
    }

    @Composable
    private fun composite(
        node: NodeInfo,
        content: @Composable () -> Unit
    ) {
        val args = remember {
            buildArgsItem(node)
        }
        
        val navArgs = remember {
            navigationArgsInstance { args }
        }

        CompositionLocalProvider(LocalNavigationArgs provides navArgs) {
            content()
        }

        DisposableEffect(node) {
            onDispose {
                saveArgsItem(node, args)
            }
        }
    }

    private fun navigationArgsInstance(body: () -> Any?): NavigationArgs {
        return object : NavigationArgs(body) {}
    }

    private fun buildArgsItem(node: NodeInfo): Any? = when (node.id) {
        "one.devsbox.www.ui.apps.wheel.detail.AppWheelDUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.apps.wheel.edit.AppWheelEUI" -> one.devsbox.www.tools.ArgsIdWithParent().fill(node.args)
        "one.devsbox.www.ui.resources.detail.ResourceUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.resources.ListingResourcesUI" -> one.devsbox.www.ui.resources.ArgsListingResource().fill(node.args)
        "one.devsbox.www.ui.users.detail.UserDUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.users.activity.UsersActivityUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.users.edit.UserEUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.devices.detail.DeviceDUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.devices.edit.DeviceEUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.campaigns.detail.CampaignDUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.campaigns.edit.CampaignEUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.company.detail.CompanyDUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.company.edit.CompanyEUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.locations.detail.LocationDUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.locations.edit.LocationEUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)
        "one.devsbox.www.ui.uploader.UploaderUI" -> one.devsbox.www.ui.uploader.UploaderArgs().fill(node.args)
        "one.devsbox.www.ui.cmd.CmdUI" -> one.devsbox.www.tools.ArgsId().fill(node.args)

        else -> null
    }   

    private fun saveArgsItem(node: NodeInfo, argsItem: Any?) {
        when (argsItem) {
            is one.devsbox.www.tools.ArgsId -> node.args = argsItem.asBundle()
            is one.devsbox.www.tools.ArgsIdWithParent -> node.args = argsItem.asBundle()
            is one.devsbox.www.ui.resources.ArgsListingResource -> node.args = argsItem.asBundle()
            is one.devsbox.www.ui.uploader.UploaderArgs -> node.args = argsItem.asBundle()

        }
    }
} 
